import { defineQuery } from 'next-sanity';

export const getThemeSetting = defineQuery(`
  *[_type == "themeSetting"][0]{
    title,
    description,
    header,
    metaDescription,
    CSS, JS
  }
    `);

export const getThemeCategory = defineQuery(`
  {
  "themeCategoryList": *[_type == "themeCategory"] | order(header asc){
    "header": title,
    slug,
    },
    "themeBanner": *[_type == "themeCategory" && ($category==null || slug.current == $category)][0].image.asset->url,
    "themeBannerBlur": *[_type == "themeCategory" && ($category==null || slug.current == $category)][0].image {
      "imgAsset": asset-> {
        ...,
      }
    },
    "themeDesc": *[_type == "themeCategory" && ($category==null || slug.current == $category)][0].description
  }
    `);

export const getThemeInformation = defineQuery(`
    *[_type == "themeCategory" && (slug.current == $category)][0]{
   description,
   image{
    asset->{
     url
    }
  }
  }
    `);

export const getThemeSeoData = defineQuery(`
   *[_type == "themeSetting"]{
   title,
    metaDescription
   }
`);

export const getThemeSlugSeoData = defineQuery(`
   *[_type == "themeCategory" && slug.current == $slug][0]{
   title,
   slug,
   metaDescription,
   image
   }
  `);
// @sanity-typegen-ignore
export const getThemeItems = defineQuery(`
  {
    "items": *[_type == "theme"
   && ($category == null || category->slug.current == $category)
  && ($tiers == null || premium == $tiers)
    ] | order(title asc) [($page - 1) * $limit...$page * $limit] {
  "caption": title,
  "largeURL": image.asset->url,
  "thumbnailURL": image.asset->url,
  "thumbnailBlurURL": image.asset->metadata.lqip,
  premium,
  category->{
  title
  }
    },
  "total": count(*[_type == "theme"
  && ($category == null || category->slug.current == $category)
  && ($tiers == null || premium == $tiers)
    ])
  }
    `);
